module.exports = __webpack_public_path__ + "static/media/back_product.64fc6563.jpg";